export default {"src":"/_next/static/media/icon_store_v2_plus_final.649c5fd4.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};